<div class="flex-container mt-3">
  <div class="mt-3" class="first-column">
    <img style="margin-top:5%;" src="/assets/img/qr.jpg" width="300px" height="208px" />
  </div>
  <div class="qrtext" class="second-column fc-black text-start">
    <div class="text-center mb-3">
      <button class="fc-black" 
        mat-stroked-button (click)="openQRScanner()">Escanear Código QR</button>
    </div>
    <p>Escanea el QR para insertar automáticamente facturas y contactos. (Asegúrese de disponer de cámara web)</p>
    <p>Al añadir una factura recibida, se añadirá automáticamente al emisor como Proveedor, en la sección Contactos.
    </p>
  </div>
</div>